import { SxProps, Typography, TypographyProps } from '@mui/material';
import useFocus from '../../../utils/hooks/useFocus';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

interface Props extends TypographyProps {
	shouldFocus?: boolean;
	text: string;
}

const sxStyle: SxProps = {
  fontFamily: "UnimedSans-Bold",
  color: "#383838",
  fontSize: "24px",
  lineHeight: "30px",
  letterSpacing: "0em",
  textAlign: "left",
  textWrap: 'wrap',
  '@media(max-width: 799px)': {
    width: '100%'
  },
}

const PageTitle: React.FC<Props> = ({ shouldFocus = true, text, ...typographyProps }) => {

  const focusRef = useFocus();
	const accessibility = useAccessibility();

  return (
    <>
      <div
        ref={shouldFocus ? focusRef : null}
        tabIndex={-1}
        style={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          margin: '-1px',
          border: '0',
          padding: '0',
          overflow: 'hidden',
          clip: 'rect(0 0 0 0)',
          whiteSpace: 'nowrap',
        }}
      >
      </div>
      <Typography
        component="h1"
        sx={sxStyle} 
        style={accessibility.textTitleStyleAccessibility}
        aria-label={text}
        { ...typographyProps }
      >{text}</Typography>
    </>
  )
}

export default PageTitle;